import { EmailTemplate } from 'screens/mass-mail/types';

/**
 * Quick reply templates for tenant communication
 * These are context-specific templates that can be injected into mass-mail
 */
export const HELPDESK_TENANT_TEMPLATES: EmailTemplate[] = [
  {
    id: 'helpdesk_request_photos',
    subject: 'Extra foto\'s nodig - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Bedankt voor uw melding betreffende: <strong>{ticketTitle}</strong></p>

<p>Om uw probleem beter te kunnen beoordelen, zouden we graag wat extra foto's ontvangen van de situatie. Kunt u ons enkele duidelijke foto's doorsturen die het probleem goed in beeld brengen?</p>

<p>U kunt de foto's rechtstreeks beantwoorden op deze e-mail.</p>

<p>Alvast bedankt voor uw medewerking!</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Vraag voor extra foto\'s',
  },
  {
    id: 'helpdesk_schedule_visit',
    subject: 'Afspraak voor bezoek - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Bedankt voor uw melding betreffende: <strong>{ticketTitle}</strong></p>

<p>Een van onze medewerkers zou graag langskomen om de situatie ter plaatse te bekijken. We stellen voor om langs te komen op <strong>[DATUM EN TIJDSTIP IN TE VULLEN]</strong>.</p>

<p>Bent u op dat moment thuis? Zo niet, laat ons dan weten wanneer het u beter uitkomt.</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Afspraak maken voor bezoek',
  },
  {
    id: 'helpdesk_request_checks',
    subject: 'Controle verzoek - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Bedankt voor uw melding betreffende: <strong>{ticketTitle}</strong></p>

<p>Om uw probleem beter te kunnen analyseren, zouden we u willen vragen om volgende zaken na te kijken en ons per kerende mail uw bevindingen door te geven:</p>

<ul>
<li>Controleer of alle stopcontacten in de betreffende ruimte nog werken</li>
<li>Kijk na of de hoofdschakelaar nog aan staat</li>
<li>Controleer of er zichtbare schade is aan bedrading of apparaten</li>
<li>Noteer wanneer het probleem voor het eerst optrad</li>
</ul>

<p>Deze informatie helpt ons om het probleem sneller en efficiënter op te lossen.</p>

<p>Alvast bedankt voor uw medewerking!</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Vraag om controles uit te voeren',
  },
  {
    id: 'helpdesk_phone_followup',
    subject: 'Opvolging telefoongesprek - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Zoals telefonisch besproken betreffende uw melding: <strong>{ticketTitle}</strong></p>

<p>Hierbij de afspraken die we hebben gemaakt:</p>

<ul>
<li>[AFSPRAAK 1 - AAN TE VULLEN]</li>
<li>[AFSPRAAK 2 - AAN TE VULLEN]</li>
</ul>

<p>Mocht u nog vragen hebben, aarzel dan niet om contact met ons op te nemen.</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Telefonische opvolging',
  },
  {
    id: 'helpdesk_contractor_scheduled',
    subject: 'Interventie ingepland - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Bedankt voor uw geduld betreffende uw melding: <strong>{ticketTitle}</strong></p>

<p>We hebben een aannemer kunnen inplannen voor <strong>[DATUM EN TIJDSTIP IN TE VULLEN]</strong>. De aannemer zal contact met u opnemen om de exacte timing af te stemmen.</p>

<p>Gelieve ervoor te zorgen dat u of iemand anders aanwezig is om de aannemer toegang te verlenen.</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Aannemer ingepland',
  },
  {
    id: 'helpdesk_temporary_solution',
    subject: 'Tijdelijke oplossing - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Betreffende uw melding: <strong>{ticketTitle}</strong></p>

<p>We hebben een tijdelijke oplossing voorzien om het ongemak te beperken. Een definitieve oplossing wordt zo snel mogelijk uitgewerkt.</p>

<p>Instructies voor de tijdelijke oplossing:</p>
<ul>
<li>[INSTRUCTIE 1 - AAN TE VULLEN]</li>
<li>[INSTRUCTIE 2 - AAN TE VULLEN]</li>
</ul>

<p>Mocht de tijdelijke oplossing niet werken of mocht u andere problemen ondervinden, neem dan onmiddellijk contact met ons op.</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Tijdelijke oplossing',
  },
  {
    id: 'helpdesk_parts_ordered',
    subject: 'Onderdelen besteld - Ticket H{ticketId}',
    content: `<p>Beste {contact.firstName},</p>

<p>Betreffende uw melding: <strong>{ticketTitle}</strong></p>

<p>We hebben de nodige onderdelen besteld om uw probleem op te lossen. De verwachte levertijd is <strong>[LEVERTIJD IN TE VULLEN]</strong>.</p>

<p>Zodra de onderdelen zijn geleverd, zullen we contact met u opnemen om een afspraak in te plannen voor de reparatie.</p>

<p>Bedankt voor uw geduld.</p>

<p>Met vriendelijke groeten,<br/>
Het Yally team</p>`,
    templateType: 'Helpdesk',
    label: 'Onderdelen besteld',
  }
];

/**
 * Quick reply templates for supplier communication
 */
export const HELPDESK_SUPPLIER_TEMPLATES: EmailTemplate[] = [
  {
    id: 'helpdesk_supplier_quote_request',
    subject: 'Offerte aanvraag - Ticket HS{ticketId}',
    content: `<p>Beste leverancier,</p>

<p>Graag vragen we een offerte aan voor de volgende werkzaamheden:</p>

<p><strong>Ticket:</strong> HS{ticketId} - {ticketTitle}</p>
<p><strong>Locatie:</strong> {buildingId}{unitInfo}</p>

<p>Kunt u ons een gedetailleerde offerte opsturen inclusief:</p>
<ul>
<li>Materiaalkosten</li>
<li>Arbeidskosten</li>
<li>Verwachte uitvoeringstijd</li>
<li>Beschikbaarheid</li>
</ul>

<p>Met vriendelijke groeten,<br/>
Yally Helpdesk Team</p>`,
    templateType: 'Helpdesk Leverancier',
    label: 'Offerte aanvraag',
  },
  {
    id: 'helpdesk_supplier_schedule_work',
    subject: 'Werk inplannen - Ticket HS{ticketId}',
    content: `<p>Beste leverancier,</p>

<p>We willen graag de werkzaamheden voor ticket HS{ticketId} inplannen.</p>

<p><strong>Locatie:</strong> {buildingId}{unitInfo}</p>
<p><strong>Werkzaamheden:</strong> {ticketTitle}</p>

<p>Kunt u ons laten weten wanneer u beschikbaar bent? We geven de voorkeur aan:</p>
<ul>
<li>[VOORKEURSDATUM/TIJD IN TE VULLEN]</li>
<li>[ALTERNATIEVE DATUM/TIJD IN TE VULLEN]</li>
</ul>

<p>Contactgegevens ter plaatse: [IN TE VULLEN]</p>

<p>Met vriendelijke groeten,<br/>
Yally Helpdesk Team</p>`,
    templateType: 'Helpdesk Leverancier',
    label: 'Werk inplannen',
  },
  {
    id: 'helpdesk_supplier_follow_up',
    subject: 'Opvolging - Ticket HS{ticketId}',
    content: `<p>Beste leverancier,</p>

<p>We volgen graag op betreffende de werkzaamheden voor ticket HS{ticketId}.</p>

<p>Kunt u ons een update geven over:</p>
<ul>
<li>De huidige status van de werkzaamheden</li>
<li>Eventuele problemen of vertragingen</li>
<li>Verwachte datum van afronding</li>
</ul>

<p>Met vriendelijke groeten,<br/>
Yally Helpdesk Team</p>`,
    templateType: 'Helpdesk Leverancier',
    label: 'Opvolging werkzaamheden',
  },
  {
    id: 'helpdesk_supplier_work_completed',
    subject: 'Werkzaamheden afgerond? - Ticket HS{ticketId}',
    content: `<p>Beste leverancier,</p>

<p>Zijn de werkzaamheden voor ticket HS{ticketId} afgerond?</p>

<p>Gelieve ons te bevestigen en eventueel foto's van het uitgevoerde werk door te sturen.</p>

<p>Ook ontvangen we graag:</p>
<ul>
<li>Factuur voor de uitgevoerde werkzaamheden</li>
<li>Garantie informatie (indien van toepassing)</li>
<li>Eventuele aanbevelingen voor onderhoud</li>
</ul>

<p>Met vriendelijke groeten,<br/>
Yally Helpdesk Team</p>`,
    templateType: 'Helpdesk Leverancier',
    label: 'Bevestiging afronding',
  }
];

/**
 * Get templates based on communication mode
 */
export const getHelpdeskTemplates = (communicationMode: 'tenant' | 'supplier'): EmailTemplate[] => {
  return communicationMode === 'supplier' 
    ? HELPDESK_SUPPLIER_TEMPLATES 
    : HELPDESK_TENANT_TEMPLATES;
};
